import React from 'react';
import AddIcon from '@mui/icons-material/Add';

import { SidebarMenuButton, SidebarMenuItem } from 'src/component/ds/ui/sidebar';
import { navRowClassName } from './navRow';
import DeviceNavCount from './DeviceNavCount';
import DeviceNavRowAction from './DeviceNavRowAction';

interface DeviceNavAllItemProps {
  label: string;
  addLabel: string;
  total: number | null;
  active: boolean;
  onSelect: () => void;
}

/* "All Panels / Groups / Connections": clears the node selection. */
export default function DeviceNavAllItem ({ label, addLabel, total, active, onSelect }: DeviceNavAllItemProps) {
  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        isActive={active}
        aria-current={active ? 'true' : undefined}
        onClick={onSelect}
        className={navRowClassName}
      >
        <span>{label}</span>
      </SidebarMenuButton>
      {total !== null && <DeviceNavCount count={total} className='ds-right-9' />}
      {/* Stub: adding a panel, group or connection isn't built yet. */}
      <DeviceNavRowAction label={addLabel} icon={<AddIcon aria-hidden='true' />} />
    </SidebarMenuItem>
  );
}
